import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { QuickWinSection } from '../components/QuickWinSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-main font-sans text-body" data-id="element-310">
      {/* Offer Banner */}
      <div className="bg-[#111111] text-[#F6F1E8] text-center py-2.5 px-4" data-id="element-311">
        <p className="text-sm tracking-wide" data-id="element-312">
          Precio de lanzamiento 24h: acceso al pack por{' '}
          <span className="font-bold text-accent" data-id="element-313">12€</span>.
        </p>
        <p className="text-xs text-gray-400 mt-0.5" data-id="element-314">
          Pago único · Acceso inmediato · Garantía 14 días · Pack digital
        </p>
      </div>

      {/* Navigation / Logo */}
      <nav className="w-full py-3 px-6 z-50" data-id="element-315">
        <div className="max-w-7xl mx-auto flex justify-center items-center" data-id="element-316">
          <div className="text-xl font-serif font-bold tracking-wider text-title" data-id="element-317">
            MÉTODO FACELESS<span className="text-accent" data-id="element-318">.</span>
          </div>
        </div>
      </nav>

      <main data-id="element-319">
        <HeroSection data-id="element-320" />
        <ProblemSection data-id="element-321" />
        <SolutionSection data-id="element-322" />
        <WhatInsideSection data-id="element-323" />
        <QuickWinSection data-id="element-324" />
        <TestimonialsSection data-id="element-325" />
        <BonusSection data-id="element-326" />
        <PricingSection data-id="element-327" />
        <FAQSection data-id="element-328" />
        <CTASection data-id="element-329" />
      </main>
      <Footer data-id="element-330" />
    </div>;
}